module.exports = __webpack_public_path__ + "static/media/header-asi.fed8fa1d.png";